import type { Sx } from '@/shared/types/uiTypes';

export const tableContainerSx: Sx = {
  pb: '24px',
  width: '100%',
  height: 'fit-content'
};

export const tableSx: Sx = {
  '& tr > :is(td, th):last-child': { pr: 2 }
};

export const tableHeadRowSx: Sx = theme => ({
  '& td, & th': {
    pb: 1,
    borderBottom: `0.5px solid ${theme.palette.gx.text}`,
    backgroundColor: 'gx.tileDark'
  }
});

export const sectionHeaderRowSx: Sx = {
  '&:first-of-type td, &:first-of-type th': { pt: 1 }
};

export const sectionNameCellSx: Sx = { fontWeight: 700 };

export const shortTitleCellSx: Sx = { width: '33%' };

export const dataRowSx: Sx = {
  '&:last-child td, &:last-child th': { pb: 1 },
  '&:first-of-type td, &:first-of-type th': { pt: 1 }
};
